<app-header *ngIf="commonHead"></app-header>
<app-header-user *ngIf="loggedHead"></app-header-user>
<router-outlet></router-outlet>

<app-footer></app-footer>
